<section class="flex flex-col gap-5 rounded-2xl border border-border bg-card p-6 shadow-sm">
  <header class="flex flex-wrap items-start justify-between gap-3 border-b border-border pb-3">
    <div class="flex min-w-0 flex-col gap-1">
      <p class="cmt-eyebrow">Domains</p>
      <p class="text-sm text-muted-foreground">
        Allowed web domains for this brand (MANDANT_DOMAIN).
      </p>
    </div>
    <button
      hlmBtn
      variant="default"
      size="sm"
      type="button"
      (click)="openAdd()"
      [disabled]="!canWrite()"
      [attr.title]="!canWrite() ? 'Read-only access — needs amie.brandManager.write to enable' : null"
    >
      <hlm-icon name="lucidePlus" size="0.9rem" /> Add domain
    </button>
  </header>

  @if (loading()) {
    <div class="flex items-center gap-3 py-4 text-sm text-muted-foreground">
      <hlm-spinner size="20" /> Loading brand domains…
    </div>
  } @else if (domains().length === 0) {
    <div class="rounded-xl border border-dashed border-border bg-card/50 p-8 text-center text-sm text-muted-foreground">
      No domains configured for this brand yet. Click
      <span class="font-medium text-foreground">Add domain</span> to add the first one.
    </div>
  } @else {
    <!-- Definite-height wrapper + normal layout so AG-Grid scrolls internally
         and pins the column header (native behaviour). -->
    <div class="h-[28rem]">
      <ag-grid-angular
        class="ag-theme-material cmt-brand-grid h-full"
        [rowData]="domains()"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [context]="gridContext"
        [getRowId]="getRowId"
        [suppressHorizontalScroll]="true"
        (firstDataRendered)="onFirstDataRendered($event)"
        (gridSizeChanged)="onGridSizeChanged($event)"
      />
    </div>
  }
</section>
